/* t22-konto.js — kontopanelen i tema 22 (2026-10-08).
   Köp igen (samma varianter till varukorgen), Sparat och Nyligen sedda ur webbläsarens minne
   (nycklarna t22-sparade och t22-sedda, som produktsidan skriver), flikarna i design 2 och arken
   i design 4. Utan JS syns allt under varandra. */
(function () {
  var rot = document.querySelector('[data-t22ko]');
  if (!rot) return;
  rot.classList.add('js');

  function lasLista(nyckel) {
    try { var x = JSON.parse(localStorage.getItem(nyckel) || '[]'); return Array.isArray(x) ? x : []; } catch (e) { return []; }
  }
  function kr(oren) {
    var t = (oren / 100).toFixed(2).replace('.', ',').replace(',00', '');
    return t.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* Köp igen */
  rot.addEventListener('click', function (e) {
    var k = e.target.closest('[data-t22ko-kop]');
    if (!k) return;
    var items;
    try { items = JSON.parse(k.getAttribute('data-t22ko-kop')); } catch (err) { return; }
    if (!items || !items.length) return;
    k.disabled = true;
    var text = k.textContent;
    k.textContent = 'Lägger i korgen…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
    }).catch(function () {
      k.disabled = false;
      k.textContent = text;
      var p = document.createElement('p');
      p.className = 't22ko-liten';
      p.setAttribute('role', 'alert');
      p.textContent = 'Varan gick inte att lägga i korgen. Den kan vara slutsåld.';
      k.parentNode.appendChild(p);
    });
  });

  /* Sparat och Nyligen sedda */
  rot.querySelectorAll('[data-t22ko-antal]').forEach(function (el) {
    el.textContent = lasLista(el.getAttribute('data-t22ko-antal')).length;
  });
  rot.querySelectorAll('[data-t22ko-lista]').forEach(function (box) {
    var handles = lasLista(box.getAttribute('data-t22ko-lista')).slice(0, 4);
    var rad = box.querySelector('[data-t22ko-rad]');
    var tom = box.querySelector('[data-t22ko-tom]');
    if (!handles.length) {
      if (box.hasAttribute('data-t22ko-dold-om-tom')) box.hidden = true;
      return;
    }
    if (tom) tom.hidden = true;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (lista) {
      var html = '';
      lista.forEach(function (p) {
        if (!p) return;
        var bild = p.featured_image ? p.featured_image.replace(/^\/\//, 'https://') : '';
        if (bild) bild += (bild.indexOf('?') > -1 ? '&' : '?') + 'width=300';
        html += '<a class="t22ko-sparat__kort" href="/products/' + esc(p.handle) + '">' +
          (bild ? '<img src="' + esc(bild) + '" alt="" width="150" height="150" loading="lazy">' : '') +
          '<span>' + esc(p.title) + '</span><b>' + (p.price_varies ? 'Från ' : '') + kr(p.price) + '</b></a>';
      });
      rad.innerHTML = html;
      if (!html) {
        if (box.hasAttribute('data-t22ko-dold-om-tom')) box.hidden = true;
        else if (tom) tom.hidden = false;
      }
    });
  });

  /* Design 2: menyn byter avsnitt */
  var flikar = rot.querySelector('[data-t22ko-flikar]');
  if (flikar) {
    var visa = function (namn, fokus) {
      var finns = rot.querySelector('[data-panel="' + namn + '"]');
      if (!finns) namn = 'oversikt';
      rot.querySelectorAll('[data-panel]').forEach(function (s) {
        if (s.getAttribute('data-panel') === namn) s.setAttribute('data-vald', ''); else s.removeAttribute('data-vald');
      });
      flikar.querySelectorAll('[data-flik]').forEach(function (a) {
        if (a.getAttribute('data-flik') === namn) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      if (fokus) { var h = rot.querySelector('[data-panel="' + namn + '"] h1, [data-panel="' + namn + '"] h2'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } }
    };
    flikar.addEventListener('click', function (e) {
      var a = e.target.closest('[data-flik]');
      if (!a) return;
      e.preventDefault();
      visa(a.getAttribute('data-flik'), true);
      history.replaceState(null, '', '#t22ko-' + a.getAttribute('data-flik'));
    });
    visa((location.hash || '').replace('#t22ko-', '') || 'oversikt', false);
  }

  /* Design 4: rutorna öppnar ark underifrån */
  var yta = rot.querySelector('[data-ark-yta]');
  if (yta) {
    var sista = null;
    var stang = function () {
      yta.removeAttribute('data-oppen');
      document.documentElement.classList.remove('t22ko-las');
      if (sista) sista.focus();
    };
    yta.querySelectorAll('.t22ko-ark').forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 't22ko-ark__stang'; b.setAttribute('aria-label', 'Stäng'); b.textContent = '×';
      b.addEventListener('click', stang);
      a.insertBefore(b, a.firstChild);
      a.setAttribute('role', 'dialog');
      a.setAttribute('aria-modal', 'true');
    });
    rot.querySelectorAll('[data-ark]').forEach(function (k) {
      k.addEventListener('click', function () {
        sista = k;
        var namn = k.getAttribute('data-ark');
        yta.querySelectorAll('.t22ko-ark').forEach(function (a) {
          if (a.getAttribute('data-ark-panel') === namn) a.setAttribute('data-vald', ''); else a.removeAttribute('data-vald');
        });
        yta.setAttribute('data-oppen', '');
        document.documentElement.classList.add('t22ko-las');
        var x = yta.querySelector('[data-vald] .t22ko-ark__stang');
        if (x) x.focus();
      });
    });
    yta.addEventListener('click', function (e) { if (e.target === yta) stang(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && yta.hasAttribute('data-oppen')) stang(); });
  }
})();
